import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { useStateIfMounted } from "use-state-if-mounted";
import { DEFAULT_PERMIT_GROUP_INFO_STATE } from "./PermitGroupsConstants";

export const useBasicPermitGroupInfo = (
  selectedPermitGroup,
  triggerRefetch
) => {
  const { getAccessTokenSilently } = useAuth0();

  const [editorState, setEditorState] = useStateIfMounted(
    DEFAULT_PERMIT_GROUP_INFO_STATE
  );
  const [isDirty, setIsDirty] = useStateIfMounted(false);

  const handleUpdateState = (name, value) => {
    if (!isDirty) setIsDirty(true);
    setEditorState((prevState) => {
      let newFilterValues = { ...prevState };
      newFilterValues[name] = value;

      if (name === "removed") {
        newFilterValues["should_remove"] = value;
      }

      return newFilterValues;
    });
  };

  const handleResetState = () => {
    setIsDirty(false);
    if (selectedPermitGroup) {
      setEditorState(data);
    } else {
      setEditorState(DEFAULT_PERMIT_GROUP_INFO_STATE);
    }
  };

  const { data, isFetching, error, refetch } = useQuery(
    ["list-permit-groups", selectedPermitGroup],
    async () => {
      if (!selectedPermitGroup) {
        setIsDirty(false);
        setEditorState(DEFAULT_PERMIT_GROUP_INFO_STATE);
        return {};
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/list-permit-groups/${selectedPermitGroup}`,
          { headers }
        );
        setIsDirty(false);
        setEditorState(data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  const {
    data: linkedPermitsTableData,
    isFetching: linkedPermitsTableIsFetching,
    error: linkedPermitsTableError,
    refetch: linkedPermitsTableRefetch,
  } = useQuery(
    ["ui-list-permits", selectedPermitGroup, triggerRefetch],
    async () => {
      if (!selectedPermitGroup) {
        return [];
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/ui-list-permits/${selectedPermitGroup}`,
          { headers }
        );
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  return {
    data,
    isLoading: isFetching,
    error,
    refetch,
    isDirty,
    lookups: {},
    tables: {
      linkedPermits: {
        data: linkedPermitsTableData,
        isFetching: linkedPermitsTableIsFetching,
        error: linkedPermitsTableError,
        refetch: linkedPermitsTableRefetch,
      },
    },
    handleUpdateState,
    handleResetState,
    state: editorState,
    setter: setEditorState,
  };
};
